import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FolderGrid = _resolveComponent("FolderGrid")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_FolderGrid, {
        key: 0,
        items: _ctx.folders
      }, null, 8, ["items"]))
    : _createCommentVNode("", true)
}